'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fileExtension = require('file-extension');

var _fileExtension2 = _interopRequireDefault(_fileExtension);

var _reactDeviceDetect = require('react-device-detect');

var _Container = require('./components/Container.FileManager');

var _Container2 = _interopRequireDefault(_Container);

var _Box = require('./components/Box.FileManager');

var _Box2 = _interopRequireDefault(_Box);

var _NoFolders = require('./components/NoFolders.FileManager');

var _NoFolders2 = _interopRequireDefault(_NoFolders);

var _Loading = require('./components/Loading.FileManager');

var _Loading2 = _interopRequireDefault(_Loading);

var _Manager = require('./components/Manager.FileManager');

var _Manager2 = _interopRequireDefault(_Manager);

var _Folder = require('./components/Folder.FileManager');

var _Folder2 = _interopRequireDefault(_Folder);

var _File = require('./components/File.FileManager');

var _File2 = _interopRequireDefault(_File);

var _Uploader = require('./components/Uploader.FileManager');

var _Uploader2 = _interopRequireDefault(_Uploader);

var _TypeSelector = require('./components/TypeSelector.FileManager');

var _TypeSelector2 = _interopRequireDefault(_TypeSelector);

var _Attributes = require('./components/Attributes.FileManager');

var _Attributes2 = _interopRequireDefault(_Attributes);

var _Uploading = require('./components/Uploading.FileManager');

var _Uploading2 = _interopRequireDefault(_Uploading);

var _FilePreview = require('./components/FilePreview.FileManager');

var _FilePreview2 = _interopRequireDefault(_FilePreview);

var _downloadFile = require('../../libs/downloadFile');

var _downloadFile2 = _interopRequireDefault(_downloadFile);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components
// Libs


var FileManager = function (_Component) {
  _inherits(FileManager, _Component);

  function FileManager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FileManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileManager.__proto__ || Object.getPrototypeOf(FileManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      openFolders: [],
      file: null,
      filePreview: null
    }, _this.toggleFolder = function (folder) {
      if (!_this.mounted) return;
      var openFolders = _this.state.openFolders;

      _this.setState({
        openFolders: openFolders.includes(folder) ? [].concat(_toConsumableArray(openFolders)).filter(function (op) {
          return op !== folder;
        }) : [].concat(_toConsumableArray(openFolders), [folder])
      });
    }, _this.onDownload = function (url, name) {
      return (0, _downloadFile2.default)(url, name);
    }, _this.onRemove = function (id) {
      var _this$props = _this.props,
          loading = _this$props.loading,
          updating = _this$props.updating;
      if (loading || updating.includes(id)) return;

      _this.props.onRemove(id);
    }, _this.getFiles = function () {
      var folder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return [].concat(_toConsumableArray(_this.props.files)).filter(function (file) {
        return file.folder === folder;
      });
    }, _this.resetUpload = function () {
      if (!_this.mounted) return;

      _this.setState({
        file: null,
        filePreview: null
      });
    }, _this.onFile = function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
          file = _ref3[0];

      if (!_this.mounted) return;
      var reader = new FileReader();

      reader.onload = function (e) {
        return _this.setState({
          filePreview: e.target.result
        });
      };

      reader.readAsDataURL(file);

      _this.setState({
        file: file
      });
    }, _this.onType = function (folder) {
      _this.props.onType(folder.key);
    }, _this.onUpload = function () {
      var file = _this.state.file;
      if (!file) return;

      _this.props.onUpload({
        file: file,
        done: _this.resetUpload
      });
    }, _this.onBack = function () {
      if (!_this.mounted) return;
      var _this$props2 = _this.props,
          folders = _this$props2.folders,
          onType = _this$props2.onType,
          type = _this$props2.type,
          clearFileOnBack = _this$props2.clearFileOnBack;
      if (!!type) onType(null);
      var file = !folders.length || clearFileOnBack ? null : _this.state.file;

      _this.setState({
        file: file
      });
    }, _this.renderUploader = function () {
      var file = _this.state.file;
      var _this$props3 = _this.props,
          uploading = _this$props3.uploading,
          small = _this$props3.small,
          folders = _this$props3.folders,
          type = _this$props3.type,
          children = _this$props3.children;
      if (uploading) return _react2.default.createElement(_Uploading2.default, {
        small: small
      });
      if (!!file && (!!type || !type && !folders.length)) return _react2.default.createElement(_Attributes2.default, {
        onUpload: _this.onUpload,
        onBack: _this.onBack
      }, children);
      if (!!file && !type) return _react2.default.createElement(_TypeSelector2.default, {
        types: folders,
        onType: _this.onType,
        onCancel: _this.resetUpload,
        small: small
      });
      return _react2.default.createElement(_Uploader2.default, {
        onChange: _this.onFile,
        small: small
      });
    }, _this.fileDom = function (file, inner) {
      return _react2.default.createElement(_File2.default, {
        key: file.id,
        preview: file.preview,
        inner: inner,
        loading: _this.props.updating.includes(file.id),
        onDownload: function onDownload() {
          return _this.onDownload(file.download, file.name);
        },
        onRemove: function onRemove() {
          return _this.onRemove(file.id);
        },
        small: _this.props.small
      }, file.name);
    }, _this.folderDom = function (folder, sub) {
      var files = _this.getFiles(folder.key);

      return _react2.default.createElement('div', {
        key: folder.key
      }, _react2.default.createElement(_Folder2.default, {
        open: _this.state.openFolders.includes(folder.key),
        onClick: function onClick() {
          return _this.toggleFolder(folder.key);
        },
        inner: sub,
        small: _this.props.small,
        color: !!files.length
      }, folder.name), _this.state.openFolders.includes(folder.key) && !!folder.folders && !!folder.folders.length && folder.folders.map(function (f) {
        return _this.folderDom(f, true);
      }), _this.state.openFolders.includes(folder.key) && files.map(function (f) {
        return _this.fileDom(f, sub ? 'secondary' : 'primary');
      }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FileManager, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          loading = _props.loading,
          height = _props.height,
          files = _props.files,
          folders = _props.folders,
          small = _props.small,
          uploadMode = _props.uploadMode;
      var _state = this.state,
          filePreview = _state.filePreview,
          file = _state.file;
      return _react2.default.createElement(_Container2.default, {
        height: height
      }, !uploadMode && _react2.default.createElement(_Box2.default, {
        border: true
      }, loading && _react2.default.createElement(_Loading2.default, null), !loading && !files.length && !folders.length ? _react2.default.createElement(_NoFolders2.default, {
        small: small
      }) : !filePreview || !file ? _react2.default.createElement(_Manager2.default, null, folders.map(function (f) {
        return _this2.folderDom(f, false);
      }), this.getFiles().map(function (f) {
        return _this2.fileDom(f, null);
      })) : _react2.default.createElement(_FilePreview2.default, {
        src: filePreview,
        pdf: (0, _fileExtension2.default)(file.name) === 'pdf'
      })), !_reactDeviceDetect.isMobile && uploadMode && !!filePreview && !!file && _react2.default.createElement(_Box2.default, {
        border: true
      }, _react2.default.createElement(_FilePreview2.default, {
        src: filePreview,
        pdf: (0, _fileExtension2.default)(file.name) === 'pdf'
      })), _react2.default.createElement(_Box2.default, {
        full: uploadMode && (!filePreview || !file || _reactDeviceDetect.isMobile)
      }, this.renderUploader()));
    }
  }]);

  return FileManager;
}(_react.Component);

FileManager.propTypes = {
  uploadMode: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  updating: _propTypes2.default.array,
  uploading: _propTypes2.default.bool,
  height: _propTypes2.default.string,
  small: _propTypes2.default.bool,
  folders: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    name: _propTypes2.default.string.isRequired,
    uploadable: _propTypes2.default.bool,
    folders: _propTypes2.default.array
  })),
  files: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    name: _propTypes2.default.string.isRequired,
    folder: _propTypes2.default.string,
    download: _propTypes2.default.string.isRequired,
    preview: _propTypes2.default.string
  })),
  type: _propTypes2.default.string,
  children: _propTypes2.default.node,
  clearFileOnBack: _propTypes2.default.bool,
  onType: _propTypes2.default.func,
  onUpload: _propTypes2.default.func,
  onRemove: _propTypes2.default.func
};
FileManager.defaultProps = {
  uploadMode: false,
  autoHeight: false,
  loading: false,
  updating: [],
  uploading: false,
  height: '100%',
  small: false,
  folders: [],
  files: [],
  type: null,
  clearFileOnBack: false,
  onType: function onType() {
    return null;
  },
  onUpload: function onUpload() {
    return null;
  },
  onRemove: function onRemove() {
    return null;
  }
};
exports.default = FileManager;